/* Galerie produit Katy Couture : diapos, variantes, lightbox plein écran avec zoom au maintien.
   Les <img> ont pointer-events:none : tous les événements sont reçus par les conteneurs. */
(function() {
  var allSlides = Array.prototype.slice.call(document.querySelectorAll('.gallery__slide'));
  var allThumbs = Array.prototype.slice.call(document.querySelectorAll('.gallery__thumb'));
  if (!allSlides.length) return;
  var currentSlideIdx = 0;         // index WITHIN the visible list
  var currentVariantHandle = null; // null = show everything
  var isSmall = window.matchMedia('(max-width: 768px)').matches;
  function fullUrl(slide) { return (isSmall && slide.dataset.fullM) ? slide.dataset.fullM : (slide.dataset.full || slide.currentSrc || slide.src); }

  function getVisibleSlides() {
    if (currentVariantHandle === null) return allSlides;
    var filtered = allSlides.filter(function(s) { return s.dataset.variant === currentVariantHandle; });
    return filtered.length ? filtered : allSlides;
  }
  function getVisibleThumbs() {
    if (currentVariantHandle === null) return allThumbs;
    var filtered = allThumbs.filter(function(t) { return t.dataset.variant === currentVariantHandle; });
    return filtered.length ? filtered : allThumbs;
  }
  function refreshGallery() {
    var visibleSlides = getVisibleSlides();
    var visibleThumbs = getVisibleThumbs();
    allSlides.forEach(function(s) { s.classList.remove('active'); s.classList.remove('zoomed'); });
    allThumbs.forEach(function(t) {
      t.classList.remove('active');
      t.classList.toggle('hidden', visibleThumbs.indexOf(t) === -1);
    });
    if (currentSlideIdx >= visibleSlides.length) currentSlideIdx = 0;
    if (currentSlideIdx < 0) currentSlideIdx = 0;
    if (visibleSlides[currentSlideIdx]) visibleSlides[currentSlideIdx].classList.add('active');
    if (visibleThumbs[currentSlideIdx]) visibleThumbs[currentSlideIdx].classList.add('active');
    var showArrows = visibleSlides.length > 1;
    document.querySelectorAll('.gallery__arrow').forEach(function(a) { a.style.display = showArrows ? '' : 'none'; });
  }
  window.slideGallery = function(dir) {
    var visibleSlides = getVisibleSlides();
    if (!visibleSlides.length) return;
    currentSlideIdx = (currentSlideIdx + dir + visibleSlides.length) % visibleSlides.length;
    refreshGallery();
  };
  window.goToSlideByIndex = function(globalIdx) {
    var visibleSlides = getVisibleSlides();
    var localIdx = visibleSlides.indexOf(allSlides[globalIdx]);
    if (localIdx >= 0) { currentSlideIdx = localIdx; refreshGallery(); }
  };
  function inRect(el, x, y) {
    if (!el) return false;
    var r = el.getBoundingClientRect();
    return x >= r.left && x <= r.right && y >= r.top && y <= r.bottom;
  }

  // Galerie de la page : balayage, et clic sur l'image -> lightbox
  var gallery = document.querySelector('.gallery__main');
  if (gallery) {
    var startX = 0;
    gallery.addEventListener('touchstart', function(e) { startX = e.touches[0].clientX; }, { passive: true });
    gallery.addEventListener('touchend', function(e) {
      var diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) window.slideGallery(diff > 0 ? 1 : -1);
    });
    gallery.addEventListener('click', function(e) {
      if (e.target.closest && e.target.closest('.gallery__arrow')) return;
      var active = gallery.querySelector('.gallery__slide.active');
      if (inRect(active, e.clientX, e.clientY)) window.openLightbox();
    });
    gallery.addEventListener('contextmenu', function(e) { e.preventDefault(); });
  }

  /* ===================== LIGHTBOX ===================== */
  var lb = document.getElementById('lightbox');
  if (lb && lb.parentNode !== document.body) document.body.appendChild(lb); // au-dessus du header
  var lbStage = document.getElementById('lightbox-stage');
  var lbImg = document.getElementById('lightbox-img');
  var lbCounter = document.getElementById('lightbox-counter');
  var lbOpen = false;
  var ZOOM = 2.6;

  // Zoom : image agrandie de `scale` autour de son centre puis déplacée de (tx, ty).
  // Le point d'image saisi (P0, coordonnées non agrandies, relatives au centre) reste sous le doigt.
  var zooming = false, zoomTimer = null, lbMoved = false;
  var pressX = 0, pressY = 0, pressT = 0;
  var scale = 1, tx = 0, ty = 0, P0x = 0, P0y = 0, pinchStart = 0, pinchScale0 = 1;

  function center() { var r = lbImg.getBoundingClientRect(); return { x: r.left + r.width / 2, y: r.top + r.height / 2 }; }
  function baseCenter() { var c = center(); return { x: c.x - tx, y: c.y - ty }; }
  function apply() { lbImg.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')'; }
  function followPoint(fx, fy) { var c = baseCenter(); tx = fx - c.x - P0x * scale; ty = fy - c.y - P0y * scale; apply(); }
  function lbResetZoom() {
    zooming = false; scale = 1; tx = 0; ty = 0;
    clearTimeout(zoomTimer);
    if (!lbImg) return;
    lbImg.classList.remove('zooming');
    if (lbStage) lbStage.classList.remove('zooming');
    lbImg.style.transform = '';
  }
  function grab(fx, fy) { var c = baseCenter(); P0x = (fx - c.x - tx) / scale; P0y = (fy - c.y - ty) / scale; }
  function startZoom(fx, fy, s) {
    zooming = true;
    lbImg.classList.add('zooming'); lbStage.classList.add('zooming');
    grab(fx, fy); scale = s; followPoint(fx, fy);
  }

  // Chargement progressif : la version 800 px (déjà en cache) s'affiche tout de suite,
  // la grande version la remplace dès qu'elle est prête. Les voisines sont préchargées.
  var loadToken = 0;
  function setImage(slide) {
    var token = ++loadToken;
    var big = fullUrl(slide);
    var preview = slide.dataset.preview || slide.currentSrc || slide.src;
    lbImg.src = preview;
    lbImg.alt = slide.alt || '';
    if (big !== preview) {
      var im = new Image();
      im.onload = function() { if (token === loadToken) lbImg.src = big; };
      im.src = big;
    }
  }
  function preloadNeighbours() {
    var visible = getVisibleSlides();
    [currentSlideIdx + 1, currentSlideIdx - 1].forEach(function(i) {
      var s = visible[(i + visible.length) % visible.length];
      if (s) { var im = new Image(); im.src = fullUrl(s); }
    });
  }
  function lbShow() {
    var visible = getVisibleSlides();
    var slide = visible[currentSlideIdx];
    if (!slide || !lbImg) return;
    lbResetZoom();
    setImage(slide);
    lbCounter.textContent = visible.length > 1 ? (currentSlideIdx + 1) + ' / ' + visible.length : '';
    var showArrows = visible.length > 1;
    lb.querySelectorAll('.lightbox__arrow').forEach(function(a) { a.style.display = showArrows ? '' : 'none'; });
    preloadNeighbours();
  }
  window.openLightbox = function() {
    if (!lb) return;
    lbShow();
    lb.classList.add('active');
    lb.setAttribute('aria-hidden', 'false');
    document.body.classList.add('lightbox-open');
    lbOpen = true;
  };
  window.closeLightbox = function() {
    if (!lb) return;
    lb.classList.remove('active');
    lb.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('lightbox-open');
    lbResetZoom();
    lbOpen = false;
  };
  window.lightboxSlide = function(dir) { window.slideGallery(dir); lbShow(); };

  if (lb && lbStage && lbImg) {
    lb.addEventListener('contextmenu', function(e) { e.preventDefault(); });
    lb.addEventListener('dragstart', function(e) { e.preventDefault(); });
    lbStage.addEventListener('click', function(e) {
      if (!lbMoved && !inRect(lbImg, e.clientX, e.clientY)) window.closeLightbox();
    });
    document.addEventListener('keydown', function(e) {
      if (!lbOpen) return;
      if (e.key === 'Escape') window.closeLightbox();
      if (e.key === 'ArrowRight') window.lightboxSlide(1);
      if (e.key === 'ArrowLeft') window.lightboxSlide(-1);
    });
    function dist(t) { var dx = t[0].clientX - t[1].clientX, dy = t[0].clientY - t[1].clientY; return Math.sqrt(dx*dx + dy*dy); }
    function mid(t) { return { x: (t[0].clientX + t[1].clientX) / 2, y: (t[0].clientY + t[1].clientY) / 2 }; }

    // Souris
    lbStage.addEventListener('mousedown', function(e) {
      if (e.button !== 0 || !inRect(lbImg, e.clientX, e.clientY)) return;
      e.preventDefault(); lbMoved = false;
      startZoom(e.clientX, e.clientY, ZOOM);
    });
    lbStage.addEventListener('mousemove', function(e) { if (zooming) followPoint(e.clientX, e.clientY); });
    ['mouseup', 'mouseleave'].forEach(function(ev) { lbStage.addEventListener(ev, function() { if (zooming) lbResetZoom(); }); });

    // Tactile (preventDefault : pas d'appui long navigateur, pas de zoom natif de la page)
    lbStage.addEventListener('touchstart', function(e) {
      e.preventDefault();
      if (e.touches.length === 1) {
        var t = e.touches[0];
        pressX = t.clientX; pressY = t.clientY; pressT = Date.now(); lbMoved = false;
        clearTimeout(zoomTimer);
        if (inRect(lbImg, pressX, pressY)) zoomTimer = setTimeout(function() { startZoom(pressX, pressY, ZOOM); }, 140);
      } else if (e.touches.length === 2) {
        clearTimeout(zoomTimer);
        var m = mid(e.touches);
        pinchStart = dist(e.touches);
        pinchScale0 = zooming ? scale : 1;
        if (!zooming) { zooming = true; lbImg.classList.add('zooming'); lbStage.classList.add('zooming'); }
        grab(m.x, m.y);
      }
    }, { passive: false });
    lbStage.addEventListener('touchmove', function(e) {
      e.preventDefault();
      if (e.touches.length === 2 && zooming) {
        var m = mid(e.touches);
        scale = Math.min(Math.max(pinchScale0 * dist(e.touches) / pinchStart, 1), 6);
        followPoint(m.x, m.y);
        return;
      }
      var t = e.touches[0];
      if (!t) return;
      if (Math.abs(t.clientX - pressX) > 8 || Math.abs(t.clientY - pressY) > 8) lbMoved = true;
      if (zooming) followPoint(t.clientX, t.clientY);
    }, { passive: false });
    lbStage.addEventListener('touchend', function(e) {
      e.preventDefault();
      clearTimeout(zoomTimer);
      if (e.touches.length > 0) { grab(e.touches[0].clientX, e.touches[0].clientY); return; }
      var wasZooming = zooming;
      lbResetZoom();
      if (!wasZooming) {
        var p = e.changedTouches[0];
        var dx = p.clientX - pressX, dy = p.clientY - pressY;
        if (Date.now() - pressT < 400 && Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy)) {
          window.lightboxSlide(dx < 0 ? 1 : -1);
        } else if (!lbMoved && !inRect(lbImg, p.clientX, p.clientY)) {
          window.closeLightbox();
        }
      }
    }, { passive: false });
    lbStage.addEventListener('touchcancel', function() { clearTimeout(zoomTimer); lbResetZoom(); });
  }

  refreshGallery();

  // Pastilles de couleur par variante
  var colorMap = {
    'rouge': '#8B0000', 'violet': '#800080', 'floral': '#e8a0b5',
    'argent': '#C0C0C0', 'noir': '#1a1a1a', 'blanc': '#FFFDD0',
    'bleu': '#1e3a5f', 'vert': '#2d5a27', 'bordeaux': '#6b0020',
    'rose': '#e8a0b5', 'gris': '#808080', 'beige': '#d4c5a9',
    'marron': '#5c3317', 'jaune': '#d4a017', 'orange': '#cc5500',
    'turquoise': '#30a5a5', 'camel': '#c19a6b', 'or': '#c9a96e',
    'creme': '#f5f0e1', 'prune': '#5e2750', 'rouille': '#a0522d',
    'lavande': '#9b7db8', 'taupe': '#8b7d6b', 'chocolat': '#3e1c0a',
    'moutarde': '#c8a415', 'menthe': '#8fc9a9', 'saumon': '#e88771',
    'corail': '#e06050', 'cuivre': '#b87333', 'kaki': '#6b6b3d',
    'ivoire': '#f5f0e1'
  };
  fetch(window.location.pathname + '.js')
    .then(function(r) { return r.json(); })
    .then(function(product) {
      var colorsDiv = document.getElementById('product-colors');
      var colorsMobile = document.getElementById('product-colors-mobile');
      if (!colorsDiv) return;
      if (!product.variants || product.variants.length === 0) return;
      if (product.variants.length === 1 && product.variants[0].title === 'Default Title') return;
      var urlParams = new URLSearchParams(window.location.search);
      var requestedVariantId = urlParams.get('variant');
      var initialVariantIndex = 0;
      if (requestedVariantId) {
        for (var vi = 0; vi < product.variants.length; vi++) {
          if (String(product.variants[vi].id) === requestedVariantId) { initialVariantIndex = vi; break; }
        }
      }
      currentVariantHandle = product.variants[initialVariantIndex].title.toLowerCase().trim();
      currentSlideIdx = 0;
      refreshGallery();
      product.variants.forEach(function(v, i) {
        var name = v.title.toLowerCase().trim();
        var color = colorMap[name] || '#ccc';
        function createDot(container) {
          var dot = document.createElement('span');
          dot.className = 'product-color-dot' + (i === initialVariantIndex ? ' active' : '');
          dot.style.background = color;
          dot.title = v.title;
          dot.setAttribute('data-variant-index', i);
          dot.onclick = function() {
            document.querySelector('input[name="id"]').value = v.id;
            var select = document.querySelector('.form-field select');
            if (select) { select.selectedIndex = i; select.dispatchEvent(new Event('change', { bubbles: true })); }
            var url = new URL(window.location);
            url.searchParams.set('variant', v.id);
            window.history.replaceState({}, '', url);
            document.querySelectorAll('.product-color-dot').forEach(function(d) {
              d.classList.toggle('active', d.getAttribute('data-variant-index') == String(i));
            });
            currentVariantHandle = name;
            currentSlideIdx = 0;
            refreshGallery();
          };
          container.appendChild(dot);
        }
        createDot(colorsDiv);
        if (colorsMobile) createDot(colorsMobile);
      });
    })
    .catch(function() {});
})();